/* eslint-disable eqeqeq */
import { Form, Col, Row, Select } from "antd";
import { useRef, useState } from "react";
import { useSelector } from "../../../../../../store/store";
import { useHistory } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";
import { DatePicker } from "antd";
import {
  getDDMMYYYFormat,
  getHHmmFormat,
} from "../../../../../../helper/dateTimeHelper";
import { getEnv } from "../../../../../../AppConfigs";
import { MailService } from "../../../../../../services/mail/mail.service";
import { mailRegexs } from "../../../../../../constants/mailTemplateConstants";
import { additionalFormFields, formFields } from "../../constant/field-names";
import { requestStatus } from "../../../../../../constants";
import { AlternateApproverSelect } from "../../../../../../components";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../../components/styled-antd";
import { HOSummaryEmployeeRequestService } from "../../../../../../services/human-organization/summary-employee-request.service";
import { PATH, MAIL_TEMPLATE } from "../../constant";
import { RenderHelper } from "../../utils/render-helper";
import { getEmployeeDetail } from "../../utils/get-employee-detail";
import { useSoftwares } from "../../../../../../hook";
import { SystemCode } from "../../../../../../constants";
import { department } from "../../../../info-technology-process/data";
import { eApproveTitleCode } from "../../../../../../constants/bizTitle";

const { RangePicker } = DatePicker;

export function CreateForm() {
  const [pickedUser, setPickedUser] = useState("");
  const history = useHistory();
  const { getITLeadITHeadAssignee } = useSoftwares();

  const [allValue,setAllValue] = useState({})

  const [form] = Form.useForm();

  const employees = useSelector((state: any) => state.employee.employees).map(
    (value: any) => {
      return {
        ...value,
        label: value.Title + " | " + value.eMail,
        value: value.eMail + "|" + value.Title,
      };
    }
  );
  
  const softwares = useSelector((state: any) => state.systemMgmt.softwares);

  const [employeeOptions, setEmployeeOptions] = useState(employees);

  const mailtemplates = useSelector(
    (state: any) => state.systemMgmt.mailtemplates
  );
  
  const approver = useRef("");

  const siteUrl = getEnv("REACT_APP_SUMMARY_EMPLOYEE_REQUEST");

  const sendMail = async (
    approver: any,
    itRepairToolRequest: any,
    type: string
  ) => {
    const url = siteUrl + "/details/" + itRepairToolRequest.id;
    const arr = approver.split("|");
    const tomail = arr.length > 0 ? arr[0] : "";
    const name = arr.length > 1 ? arr[1] : "";
    const template = mailtemplates.find((m: any) => m.eMailType === type);
    const content = template.eContent
      .replace(mailRegexs.zero + ";", name)
      .replace(mailRegexs.one + ";", "duyệt")
      .replace(
        mailRegexs.two + ";",
        itRepairToolRequest.createdBy.user.displayName
      )
      .replace(
        mailRegexs.three + ";",
        `${getDDMMYYYFormat(
          itRepairToolRequest.createdDateTime
        )} - ${getHHmmFormat(itRepairToolRequest.createdDateTime)}`
      )
      .replace(mailRegexs.siteUrl, url);
    const subject = template.eSubject;
    const message = MailService.buildMailMesssage(
      subject,
      content,
      "html",
      tomail
    );
    await MailService.sendMail(message);
  };

  const onFinish = async (values: any) => {
    try {
      let initFields: any = {
        Title: "BẢNG TỔNG HỢP NHÂN SỰ THAM GIA KHÓA HỌC",

        eRequestStatus: requestStatus.submitted,
        eApprovedStatus: requestStatus.submitted,

        eApprovedByITLeadStatus: requestStatus.submitted,
        eApprovedByITLead: getITLeadITHeadAssignee(
          SystemCode.EBM
        ).eApprovedByITLead.split("|")[0],

        eContent: JSON.stringify([]),
        eApprovedBy: approver.current
          ? approver.current.split("|")?.[0]
          : values.eApprovedBy.split("|")?.[0],
      };

      formFields.forEach((value, index) => {
        initFields[value.field] = values[value.field];
      });

      additionalFormFields.forEach((value, index) => {
        initFields[value.field] = values[value.field];
      });

      const resp =
        await HOSummaryEmployeeRequestService.addSummaryEmployeeRequest({
          fields: {
            ...initFields,

            eCourseDate: values.eCourseDate[0],
            eCourseDateEnd: values.eCourseDate[1],
          },
        });

      sendMail(
        `${approver.current ? approver.current : values.eApprovedBy}|${
          getEmployeeDetail(
            approver.current ? approver.current : values.eApprovedBy,
            employees,
           softwares
          )?.[0]?.Title
        }`,
        resp,
        MAIL_TEMPLATE.APPROVE
      );

      CreateNotification({
        title: "Thành công",
        body: `Tạo phiếu yêu cầu thành công`,
        icon: "/icons/success.png",
      });
      history.push(PATH.HOME);
    } catch (error) {
      CreateNotification({
        title: "Thất bại",
        body: `Tạo phiếu yêu cầu thất bại`,
        icon: "/icons/error.png",
      });
      history.push(PATH.HOME);
    }
  };

  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.eDepartment) {
      const selectedDepartmentValue = department.find(
        (e: any) => e.value === changedValues.eDepartment
      );
      const newEmployees = [...employees];

      setEmployeeOptions(
        newEmployees.filter(
          (value) =>
            eApproveTitleCode.indexOf(value.eBizTitleCode) > -1 &&
            value.eDepartmentCode == selectedDepartmentValue?.id
        )
      );

      form.setFieldsValue({
        eApprovedBy: null,
        pickedUser: null,
      });
    }
  };

  return (
    <>
      <Form onFinish={onFinish} size="large" form={form} onValuesChange={onValuesChange}>
        <Row gutter={[32, 0]}>
          <RenderHelper
            allValue={allValue}
            setAllValue={setAllValue}
            form={form}
            fields={formFields}
          />

          <Col span={12}>
            <StyledTitle level={5}>
              Chọn ngày <span className="text-danger">(*)</span>
            </StyledTitle>
            <Form.Item
              name="eCourseDate"
              rules={[{ required: true, message: "Chọn ngày" }]}
            >
              <RangePicker
                style={{ width: "100%" }}
                placeholder={["Từ ngày", "Đến ngày"]}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[32, 0]}>
          <RenderHelper fields={additionalFormFields} />
        </Row>

        <Row gutter={[32, 0]}>
          <Col span={12}>
            <StyledTitle level={5}>
              Người duyệt{" "}
              {pickedUser === "" && <span className="text-danger">(*)</span>}
            </StyledTitle>
            <Form.Item
              name="eApprovedBy"
              rules={[
                { required: pickedUser === "", message: "Chọn người duyệt" },
              ]}
            >
              <Select
                options={employeeOptions}
                onChange={(value) => {
                  approver.current = value;
                }}
                placeholder="Thủ trưởng CQ/ĐV"
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <StyledTitle level={5}>Người duyệt thay thế</StyledTitle>
            <AlternateApproverSelect
              placeholder="Thủ trưởng CQ/ĐV"
              onChange={(value) => {
                if (value) {
                  approver.current = value.split("|")?.[0]?.toLowerCase() || "";
                  setPickedUser(value.split("|")?.[0]?.toLowerCase() || "");
                }
              }}
            />
          </Col>

          <Col span={24}>
            <div className="d-flex justify-content-center">
              <StyledButton
                bgColor="red"
                htmlType="submit"
                onClick={() => history.push(PATH.HOME)}
                danger
                type="primary"
              >
                Hủy
              </StyledButton>

              <StyledButton
                bgColor="yellow"
                type="primary"
                htmlType="submit"
                className="ml-3"
              >
                Xác nhận
              </StyledButton>
            </div>
          </Col>
        </Row>
      </Form>
    </>
  );
}
